<template>
  <v-card class="rounded-lg" :loading="loading" v-intersect="intersect">
    <v-row class="mx-0">
      <v-col class="" style="position: relative" cols="12" sm="4" md="3">
        <v-card
          class="d-flex flex-column justify-center pa-2 rounded-xl h-full"
          outlined
        >
          <v-img
            v-if="!$vuetify.theme.dark"
            :src="platform.logos?.dark"
            contain
            max-height="110px"
            style="cursor: pointer"
            :style="{
              filter: !platform.active ? `grayscale(80%)` : undefined,
            }"
            @click="management(platform)"
          />
          <v-img
            v-else
            :src="platform.logos?.light"
            class="rounded-lg"
            max-height="110px"
            contain
            style="cursor: pointer"
            :style="{
              filter: !platform.active ? `grayscale(80%)` : undefined,
            }"
            @click="management(platform)"
          />
        </v-card>

        <div
          class="d-flex flex-column align-start gap-1"
          style="position: absolute; top: 18px; right: 18px"
        >
          <base-copier type="chip" :value="platform.id || ''" hide-icon>
            <template v-slot:default="{ copy, icon }">
              <v-chip
                @click="copy"
                small
                label
                class="text-overline font-weight-medium"
              >
                #{{ platform.id | shortId }}
                <v-icon right x-small>{{ icon }}</v-icon>
              </v-chip>
            </template>
          </base-copier>
        </div>
      </v-col>

      <v-col cols="12" sm="">
        <div class="d-flex flex-column h-full">
          <div class="d-flex justify-space-between align-center gap-2 mr-2">
            <span class="ma-0 text-overline" style="line-height: 1em">
              {{ platform.Company.name }}
            </span>

            <v-chip
              :color="platform.active ? 'success' : 'error'"
              label
              x-small
            >
              {{ platform.active ? "Ativo" : "Inativo" }}
            </v-chip>
          </div>

          <h5 class="ma-0">{{ platform.name }}</h5>
          <v-divider class="my-2" />

          <div class="d-flex flex-column gap-1">
            <div class="d-flex align-center gap-2">
              <v-icon small>mdi-email</v-icon>
              <span>{{ platform.email }}</span>
            </div>
            <div class="d-flex align-center gap-2">
              <v-icon small>mdi-phone</v-icon>
              <span>{{ platform.phone }}</span>
            </div>
          </div>

          <PlatformDeploymentStatus class="mt-2" :platform="platform" />

          <v-spacer />

          <div class="d-flex flex-wrap align-end gap-1 mt-2 mr-2">
            <v-btn
              :href="`//${platform.domain}`"
              target="_blank"
              color="primary"
              text
              small
            >
              Visitar <v-icon right x-small>mdi-open-in-new</v-icon>
            </v-btn>
            <v-spacer />
            <!-- <v-btn
              :to="`/admin/platforms/${platform.id}`"
              color="primary"
              small
            >
              Gerenciar
            </v-btn> -->
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import PlatformDeploymentStatus from "./PlatformDeploymentStatus.vue";
export default {
  components: {
    PlatformDeploymentStatus,
  },
  data: () => ({
    visible: false,
  }),
  methods: {
    management(platform) {
      this.$router.push({
        name: "admin.platforms.management",
        params: { id: platform.id },
      });
    },
    intersect(entries) {
      if (entries[0].isIntersecting) this.visible = true;
    },
  },
  props: {
    platform: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.color-square {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
